import { jankenSfx } from 'src/game/janken/janken.sound';
import { getMatch2SoundEffects } from 'src/game/minigame/match2-timestep/game/defs/audio';
import { buddiesSfx } from 'src/game/buddies/buddies.sound';

const assets = 'assets';

export default {
  sfxPath: `${assets}/sounds/sfx`,
  musicPath: `${assets}/sounds/music`,

  music: {
    bgm: { volume: 0.1, background: true, sources: ['BGM.mp3'] },
    match2: { volume: 0.1, background: true, sources: ['Match2_BGM.mp3'] },
    rescue: { volume: 0.1, background: true, sources: ['Rescue_BGM.mp3'] },
    buddies: { volume: 0.1, background: true, sources: ['Buddies_BGM.mp3'] },
    cards: { volume: 0.1, background: true, sources: ['Match3_BGM.mp3'] },
    dreamDriftMap: {
      volume: 0.1,
      background: true,
      sources: ['DreamDrift_map_BGM.mp3'],
    },
    dreamDriftPuzzle: {
      volume: 0.1,
      background: true,
      sources: ['DreamDrift_puzzle_BGM.mp3'],
    },
  },
  sfx: {
    dreamDriftLightning: {
      volume: 1,
      background: false,
      sources: ['dreamDrift/lightning.mp3'],
    },
    dreamDriftPaintDrop: {
      volume: 1,
      background: false,
      sources: ['dreamDrift/paintdrop.mp3'],
    },
    dreamDriftPortal: {
      volume: 1,
      background: false,
      sources: ['dreamDrift/portal.mp3'],
    },
    dreamDriftTornado: {
      volume: 1,
      background: false,
      sources: ['dreamDrift/tornado.mp3'],
    },
    period: { volume: 1, background: false, sources: ['Period.mp3'] },
    speak: {
      volume: 0.5,
      background: false,
      sources: ['Speak-0.mp3', 'Speak-1.mp3', 'Speak-2.mp3'],
    },
    ok: { volume: 1, background: false, sources: ['OK.mp3'] },
    cancel: { volume: 1, background: false, sources: ['Cancel_Back.mp3'] },
    applause: { volume: 1, background: false, sources: ['Applause.mp3'] },
    tapPet: { volume: 1, background: false, sources: ['TapPet.mp3'] },
    progressAwarded: {
      volume: 1,
      background: false,
      sources: ['progress_awarded.mp3'],
    },
    progressCounted: {
      volume: 1,
      background: false,
      sources: ['progress_counted.mp3'],
    },
    move: { volume: 1, background: false, sources: ['Move.mp3'] },
    gemsCollected: { volume: 1, background: false, sources: ['Gems.mp3'] },
    ascension: { volume: 1, background: false, sources: ['Ascension.mp3'] },
    deco: { volume: 1, background: false, sources: ['Deco.mp3'] },
    milestone: { volume: 1, background: false, sources: ['Milestone.mp3'] },
    gachaTurnHandle: {
      volume: 1,
      background: false,
      sources: ['TurnHandle.mp3'],
    },
    gachaOpenCapsule: {
      volume: 1,
      background: false,
      sources: ['OpenCapsule.mp3'],
    },
    gachaItemDrop: {
      volume: 1,
      background: false,
      sources: ['GachaItemDrop.mp3'],
    },
    normalHit: {
      volume: 1,
      background: false,
      sources: ['NormalHit.mp3'],
    },
    jackpotHit: {
      volume: 1,
      background: false,
      sources: ['JackpotHit.mp3'],
    },
    fire: {
      volume: 1,
      background: false,
      sources: ['Fire.mp3'],
    },

    win: { volume: 1, background: false, sources: ['win.mp3'] },
    tada: { volume: 0.5, background: false, sources: ['tada.mp3'] },
    fireworkLaunch: {
      volume: 0.5,
      background: false,
      sources: ['firework-launch1.mp3', 'firework-launch2.mp3'],
    },
    fireworkBoom: {
      volume: 0.5,
      background: false,
      sources: [
        'firework-boom1.mp3',
        'firework-boom2.mp3',
        'firework-boom3.mp3',
        'firework-boom4.mp3',
      ],
    },

    // Append Match2 sound effects
    ...getMatch2SoundEffects(),

    // Append buddies sound effects
    ...buddiesSfx,

    // Append janken sound effects
    ...jankenSfx,
  },
};
